import styled from 'styled-components';
export const PermissionsContainer = styled.div`
  padding: 20px;
`;

export const CategoryTitle = styled.h3`
  margin: 20px 0 10px;
  font-size: 16px;
  font-weight: 500;
`;

export const PermissionItem = styled.div`
  display: flex;
  align-items: center;
  margin: 8px 0;
  padding: 8px;
  border-radius: 4px;
  background: #f5f5f5;
`;

export const PermissionDescription = styled.span`
  margin-left: 8px;
  color: #666;
  font-size: 14px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
`;